define('flight-components/EmailShareForm',['require','flight/lib/component','App','URIjs/URI','flight-components/mixins/withForm','flight-components/mixins/withCaptcha'],function(require){

  // Dependencies
  var component = require('flight/lib/component'),
      App = require('App'),
      URI = require('URIjs/URI'),
      withForm = require('flight-components/mixins/withForm'),
      withCaptcha = require('flight-components/mixins/withCaptcha');

  return component(EmailShareForm, withForm, withCaptcha);

  // Constructor
  function EmailShareForm() {

    this.defaultAttrs({
      formSelector: '.email-share-form__form',
      formUrl: App.context + '/share',
      formSuccessMsgSelector: '.form-success-msg',
      formTitleSelector: '.email-share-form__title'
    });

    this.showSuccessMsg = function() {
      this.select('formSuccessMsgSelector').show();
      this.select('formSelector').hide();
      this.select('formTitleSelector').hide();
    };

    this.getEmailUrl = function () {
      var url = URI(window.location.href);
      var emailUrl = this.$node.data('emailUrl')

      if (emailUrl)
        return emailUrl

      url.removeQuery('vpref');
      url.addQuery({
        vpref: this.$node.data('mailref')
      });
      return url.toString();
    }

    this.after('initialize', function() {
      var self = this;

      this.$node.find("input[name='url']").val(self.getEmailUrl());

      this.on('data-form-success-returned', this.showSuccessMsg);

    });

  };
});

